import { useMediaQuery } from '@mui/material'
import styled from 'styled-components'
import { staticPath } from '~/lib/$path'
import { theme } from '~/lib/theme'

/**
 * CornerImages コンポーネントは、画面の四隅にデザイン用の画像を配置するためのコンポーネントです。
 *
 * スクリーン幅が 'md' 以上の場合には、中央下部にも追加の画像が表示されます。それ以外の場合は、四隅に画像が表示されます。
 * 画像は絶対位置で配置され、各画像のサイズは最大 150px に制限されています。
 *
 * @returns {JSX.Element} 四隅に配置される CornerImage の JSX 要素を返します。
 */

export const CornerImages = () => {
  const isBreakpointUpMd = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <>
      <CornerImage src={staticPath.signin_flame.top_left_svg} alt="Top Left" style={{ top: 0, left: 0 }} />
      <CornerImage src={staticPath.signin_flame.top_right_svg} alt="Top Right" style={{ top: 0, right: 0 }} />
      {isBreakpointUpMd && (
        <CornerImage
          src={staticPath.signin_flame.bottom_middle_svg}
          alt="Bottom Middle"
          style={{ bottom: 0, left: '50%', transform: 'translateX(-50%)' }}
        />
      )}
      <CornerImage
        src={
          isBreakpointUpMd ? staticPath.signin_flame.bottom_left_svg : staticPath.signin_flame.bottom_left_mobile_svg
        }
        alt="Bottom Left"
        style={{ bottom: 0, left: 0 }}
      />
      <CornerImage
        src={
          isBreakpointUpMd ? staticPath.signin_flame.bottom_right_svg : staticPath.signin_flame.bottom_right_mobile_svg
        }
        alt="Bottom Right"
        style={{ bottom: 0, right: 0 }}
      />
    </>
  )
}

const maxCornerImageSize = 150

const CornerImage = styled('img')`
  position: absolute;
  max-width: ${maxCornerImageSize}px;
  max-height: ${maxCornerImageSize}px;
  z-index: -1;
`
